import * as React from 'react'
import { ActionsCell } from './ActionsCell'
import parse from 'html-react-parser'
import { DueAtCell } from './DueAtCell'
import { NextContactCell } from './NextContactCell'
import { useFormatTime } from '~/hooks/useFormatTime'

const headerMap = {
  type: 'Type',
  created_at: 'Created',
  candidate: 'Candidate',
  company: 'Company',
  next_meeting: 'Next Meeting',
  due_at: 'Due At',
  next_contact_date: 'Next Contact',
}

export function useCandidateActionsColumns() {
  const formatTime = useFormatTime()

  const columns = [
    {
      accessorKey: 'type',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => props.row.original.title,
      enableSorting: false,
    },
    {
      accessorKey: 'created_at',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => formatTime(props.row.original.created_at, 'short'),
      sortUndefined: 'last',
    },
    {
      accessorKey: 'candidate',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => props.row.original.candidate,
      enableSorting: false,
    },
    {
      accessorKey: 'company',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => props.row.original.company,
      enableSorting: false,
    },
    {
      accessorKey: 'next_meeting',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => parse(props.row.original.next_meeting),
      sortUndefined: 'last',
    },
    {
      accessorKey: 'due_at',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => <DueAtCell {...props} />,
      sortUndefined: 'last',
      sortAscFirst: true,
    },
    {
      accessorKey: 'next_contact_date',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => <NextContactCell {...props} />,
      sortUndefined: 'last',
    },
    {
      accessorKey: 'Actions',
      header: (props) => <BlankHeader {...props} />,
      cell: (props) => <ActionsCell {...props} />,
      enableSorting: false,
    },
  ]

  return columns
}

function TableHeader({ column }) {
  return <div className="font-roboto">{headerMap[column.id]}</div>
}

function BlankHeader() {
  return <div className="font-roboto"></div>
}
